<template>
  <div id="app">
    <router-view>

    </router-view>
  </div>
</template>

<style scoped>

</style>

<script>
  import App from "./app.ts";
  export default App;
</script>